import { LegalLayout } from "./layout";

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Policy" lastUpdated="March 23, 2026">
      <p>
        This Cookie Policy explains how Lerni uses cookies and similar technologies when you use our platform.
      </p>

      <h2>1. What Are Cookies?</h2>
      <p>
        Cookies are small text files stored in your browser when you visit a website. They help the site remember information about your visit, making your experience smoother and more consistent.
      </p>

      <h2>2. How Lerni Uses Cookies</h2>
      <p>Lerni uses cookies for the following purposes:</p>

      <h3>Authentication &amp; Session</h3>
      <p>
        We use local storage and session-based tokens to keep you logged in while you use the app. Without this, you would be signed out every time you close the browser. These are essential for the service to function and cannot be disabled.
      </p>

      <h3>Preferences</h3>
      <p>
        We store your theme preference (light or dark mode) locally in your browser so it persists between visits.
      </p>

      <h3>Third-Party Authentication</h3>
      <p>
        If you sign in with Google, Google may set cookies as part of their OAuth authentication process. These are governed by <strong>Google's Privacy Policy</strong>.
      </p>

      <h2>3. What We Do Not Use</h2>
      <p>Lerni does not use:</p>
      <ul>
        <li>Third-party advertising cookies</li>
        <li>Cross-site tracking pixels</li>
        <li>Behavioral profiling cookies</li>
      </ul>

      <h2>4. Managing Cookies</h2>
      <p>
        You can control cookies through your browser settings. Most browsers allow you to view, block, or delete cookies. Note that disabling essential cookies may prevent certain features of Lerni from working correctly, including keeping you logged in.
      </p>

      <h2>5. Changes to This Policy</h2>
      <p>
        We may update this Cookie Policy as our technology or legal requirements change. We will post any updates here with a revised "Last updated" date.
      </p>

      <h2>6. Contact</h2>
      <p>
        For any questions about cookies or how we handle your data, contact us at <strong>lernisupport@gmail.com</strong>.
      </p>
    </LegalLayout>
  );
}
